import React from "react";
import { connect } from "react-redux";
import Joi from "joi-browser";
import Form from "../comman/form";
import geo from "../services/geoService";
import { getAlert } from "../services/appAlerts";
import { getCodeManager, loadCodeManager } from "../app/store/referenceData";

class AddPartnerPerformer extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      stateList: [],
      countyList: [],
      selectedStateId: "",
      selectedState: "",
      selectedCountyId: "",
      selectedCounty: "",
      roles: [
        { id: "1", name: "Partner Admin" },
        { id: "2", name: "Partner Performer" },
      ],
      modalShow: "",
    };
  }

  async componentDidMount() {
    const stateList = await geo.getStateList();
    this.setState({ stateList });
    this.props.loadCodeManager("Partner User Role");
  }

  schema = {
    name: Joi.string().required().label("Name"),
    email: Joi.string().email().required().label("Email"),
    contact: Joi.string()
      .length(10)
      .options({
        language: {
          string: {
            length: "Mobile No. must be 10 digits.",
          },
        },
      })
      .options({})
      .regex(/^[0-9]+$/)
      .options({
        language: {
          string: {
            regex: {
              base: "This entry can only contain numbers",
            },
          },
        },
      })
      .label("Mobile No."),
  };

  doSubmit = async () => {
    const { data } = this.state;
    this.props.handleFormSubmit(data);

    if (data["id"] > 0) {
      getAlert("", `${this.props.partnerType} Updated Successfully`, "success");
    } else {
      getAlert("", `${this.props.partnerType} Added Successfully`, "success");
    }
    this.props.handlePermissionShowHide();
  };

  handleStateChanged = async ({ target: input }) => {
    const selectedOption = input.selectedOptions[0];
    this.setState({
      selectedState: selectedOption.text,
      selectedStateId: selectedOption.value,
    });

    this.updateState(input.name, selectedOption.text);

    await this.bindCountyDropdown(selectedOption.value);
  };

  handleCountyChanged = ({ target: input }) => {
    const selectedOption = input.selectedOptions[0];
    this.setState({
      selectedCounty: selectedOption.text,
      selectedCountyId: selectedOption.value,
    });

    this.updateState(input.name, selectedOption.text);
  };

  updateState(name, value) {
    const data = { ...this.state.data };
    const errors = { ...this.state.errors };
    data[name] = value;
    delete errors[name];
    this.setState({ data, errors });
  }

  formatPhone = (value) => {
    if (!value) return "";
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  handlePhoneChange = (e) => {
    this.handleChange({
      currentTarget: {
        name: e.target.name,
        value: e.target.value.replace(/[^\d]/g, ""),
      },
    });
  };

  async bindCountyDropdown(geonameId) {
    const countyList = geonameId > 0 ? await geo.getGeoData(geonameId) : [];
    this.setState({ countyList });
    return countyList;
  }

  componentWillReceiveProps = async (nextProps) => {
    const { selectedObj } = nextProps;
    if (selectedObj && selectedObj !== "") {
      const { stateList } = this.state;
      //console.log(selectedObj);
      const selectedState = stateList.filter(
        (x) => x.name === selectedObj.state
      );
      this.setState({ data: selectedObj });
      if (selectedState.length > 0) {
        this.setState({ selectedStateId: selectedState[0].geonameId });
        const countyList = await this.bindCountyDropdown(
          selectedState[0].geonameId
        );
        if (selectedObj.county !== null) {
          const selectedCounty = countyList.filter(
            (x) => x.name === selectedObj.county
          );
          if (selectedCounty.length > 0) {
            this.setState({ selectedCountyId: selectedCounty[0].geonameId });
          }
        }
      }
    } else {
      this.setState({ data: {}, selectedCountyId: "", selectedStateId: "" });
    }
  };

  render() {
    const {
      stateList,
      selectedStateId,
    } = this.state;

    const { partnerUserTypes } = this.props;
    const { data, errors } = this.state;
    const isEditMode = data && data.id > 0;
    const partnerLabel = this.props.partnerType || "Partner";

    return (
      <div className="appf-card">
        <style>{`
          @keyframes appfFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .appf-card {
            border: 1px solid rgba(226,232,240,0.8);
            border-radius: 16px;
            background: #ffffff;
            box-shadow: 0 4px 24px -4px rgba(15,23,42,0.06);
            margin-top: 10px;
            animation: appfFadeIn 0.3s ease both;
            overflow: hidden;
          }
          .appf-form-header {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 16px 22px;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            border-bottom: 1.5px solid #e2e8f0;
          }
          .appf-form-header-icon {
            width: 42px;
            height: 42px;
            border-radius: 12px;
            background: rgba(37,99,235,0.06);
            border: 1.5px solid rgba(37,99,235,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
            color: #2563eb;
            flex-shrink: 0;
          }
          .appf-form-header-text {
            min-width: 0;
            flex: 1;
          }
          .appf-form-header-title {
            color: #0f172a;
            font-size: 14.5px;
            font-weight: 600;
            margin: 0;
            line-height: 1.2;
          }
          .appf-form-header-sub {
            color: #64748b;
            font-size: 12px;
            margin-top: 3px;
            font-weight: 600;
          }
          .appf-form-header-badge {
            margin-left: auto;
            background: #f1f5f9;
            border: 1px solid #e2e8f0;
            border-radius: 999px;
            padding: 4px 12px;
            color: #475569;
            font-size: 11.5px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 6px;
            white-space: nowrap;
          }
          .appf-form-header-badge i { color: #2563eb; }
          .appf-form-body { padding: 18px 22px; }
          .appf-section { margin-bottom: 22px; }
          .appf-section:last-child { margin-bottom: 0; }
          .appf-section-header {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 14px;
            padding-bottom: 9px;
            border-bottom: 1.5px solid #f1f5f9;
          }
          .appf-section-icon {
            width: 26px;
            height: 26px;
            border-radius: 7px;
            background: rgba(37,99,235,0.08);
            border: 1px solid rgba(37,99,235,0.12);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #2563eb;
          }
          .appf-section-title {
            font-size: 11px;
            font-weight: 600;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.7px;
          }
          .appf-card .form-control-label {
            font-size: 11px !important;
            font-weight: 600 !important;
            color: #64748b !important;
            text-transform: uppercase !important;
            letter-spacing: 0.7px !important;
            margin-bottom: 6px !important;
            display: flex !important;
            align-items: center !important;
            gap: 5px !important;
          }
          .appf-card .form-control-label i { color: #94a3b8; font-size: 11px; }
          .appf-card .form-group { margin-bottom: 16px; }
          .appf-card .required .form-control-label::after {
            content: " *" !important;
            position: static !important;
            font-family: inherit !important;
            color: #ef4444 !important;
            font-weight: 600 !important;
            font-size: 13px !important;
            line-height: 1 !important;
            margin-left: 3px !important;
          }
          .appf-input-wrap { position: relative; }
          .appf-input-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #94a3b8;
            font-size: 13px;
            pointer-events: none;
            transition: color 0.2s ease;
            z-index: 1;
          }
          .appf-input-wrap:focus-within .appf-input-icon { color: #2563eb; }
          .appf-card .form-control,
          .appf-card .appf-select {
            border-radius: 9px !important;
            border: 1.5px solid #e2e8f0 !important;
            padding: 8px 13px 8px 35px !important;
            font-size: 13px !important;
            color: #1e293b !important;
            background-color: #ffffff !important;
            transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
            box-shadow: 0 1px 3px 0 rgba(0,0,0,0.03) !important;
            width: 100% !important;
          }
          .appf-card .form-control::placeholder { color: #94a3b8 !important; }
          .appf-card .form-control:hover,
          .appf-card .appf-select:hover {
            border-color: #94a3b8 !important;
            box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
          }
          .appf-card .form-control:focus,
          .appf-card .appf-select:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 4px rgba(37,99,235,0.1), 0 2px 6px -1px rgba(37,99,235,0.08) !important;
            outline: none !important;
            background-color: #fafbff !important;
          }
          .appf-card .appf-select {
            appearance: none !important;
            -webkit-appearance: none !important;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat !important;
            background-position: right 12px center !important;
            padding-right: 32px !important;
            cursor: pointer !important;
          }
          .appf-card .alert.alert-danger {
            padding: 5px 10px !important;
            font-size: 11.5px !important;
            border-radius: 7px !important;
            margin-top: 5px !important;
            margin-bottom: 0 !important;
          }
          .appf-field-hint {
            font-size: 11px;
            color: #94a3b8;
            margin-top: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
          }
          .appf-form-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 10px;
            flex-wrap: wrap;
            padding: 14px 22px;
            border-top: 1.5px solid #f1f5f9;
            background: #fafbfd;
          }
          .appf-card {
            border-color: #d1d5db !important;
            box-shadow: none !important;
          }
          .appf-form-header {
            background: #f8fafc !important;
            border-bottom-color: #e5e7eb !important;
          }
          .appf-form-header-icon,
          .appf-section-icon {
            background: #f1f5f9 !important;
            border-color: #d1d5db !important;
            color: #64748b !important;
            box-shadow: none !important;
          }
          .appf-form-header-badge i {
            color: #64748b !important;
          }
          .appf-card .form-control-label i,
          .appf-input-icon {
            display: none !important;
          }
          .appf-card .form-control,
          .appf-card .appf-select {
            padding: 8px 13px !important;
            color: #171717 !important;
            box-shadow: none !important;
          }
          .appf-card .form-control:focus,
          .appf-card .appf-select:focus {
            border-color: #737373 !important;
            background-color: #ffffff !important;
            box-shadow: 0 0 0 3px rgba(0,0,0,0.06) !important;
          }
          .appf-form-footer {
            justify-content: center !important;
            background: #ffffff !important;
          }
          @media (max-width: 575px) {
            .appf-form-header {
              align-items: flex-start;
              flex-wrap: wrap;
            }
            .appf-form-header-badge {
              margin-left: 0;
            }
          }
        `}</style>

        <div className="appf-form-header">
          <div className="appf-form-header-icon">
            <i className={`fa ${isEditMode ? "fa-pencil-square-o" : "fa-user-plus"}`} />
          </div>
          <div className="appf-form-header-text">
            <p className="appf-form-header-title">
              {isEditMode ? "Edit Partner User" : `Add New ${partnerLabel} User`}
            </p>
            <p className="appf-form-header-sub">
              {isEditMode
                ? `Updating record for ${data.name || "selected user"}`
                : `Fill in the details below to add a user for this ${partnerLabel.toLowerCase()}.`}
            </p>
          </div>
          {isEditMode && data.id && (
            <div className="appf-form-header-badge">
              <i className="fa fa-id-badge" /> User #{data.id}
            </div>
          )}
        </div>

        <div className="appf-form-body">
          <div className="appf-section">
            <div className="appf-section-header">
              <div className="appf-section-icon"><i className="fa fa-id-card-o" /></div>
              <span className="appf-section-title">Role &amp; Identity</span>
            </div>

            <div className="row">
              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfTitleSelect">
                  <i className="fa fa-tag" /> User Type
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-tag appf-input-icon" aria-hidden="true" />
                  <select
                    id="appfTitleSelect"
                    name="title"
                    className="form-control appf-select"
                    value={data.title || ""}
                    onChange={this.handleChange}
                  >
                    <option value="">Select user type</option>
                    {partnerUserTypes.map((role) => (
                      <option key={role.id || role.name} value={role.name}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>
                {errors.title && <div className="alert alert-danger">{errors.title}</div>}
                <p className="appf-field-hint">
                  <i className="fa fa-info-circle" />
                  Select the partner user role for this account.
                </p>
              </div>

              <div className="col-lg-6 form-group required">
                <label className="form-control-label" htmlFor="appfName">
                  <i className="fa fa-user" /> Full Name
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-user appf-input-icon" aria-hidden="true" />
                  <input
                    type="text"
                    name="name"
                    id="appfName"
                    value={data.name || ""}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="Full Name"
                  />
                </div>
                {errors.name && <div className="alert alert-danger">{errors.name}</div>}
              </div>

              <div className="col-lg-6 form-group required">
                <label className="form-control-label" htmlFor="appfEmail">
                  <i className="fa fa-envelope" /> Email Address
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-envelope appf-input-icon" aria-hidden="true" />
                  <input
                    type="email"
                    name="email"
                    id="appfEmail"
                    value={data.email || ""}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="Email Address"
                  />
                </div>
                {errors.email && <div className="alert alert-danger">{errors.email}</div>}
              </div>

              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfContact">
                  <i className="fa fa-phone" /> Mobile No.
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-phone appf-input-icon" aria-hidden="true" />
                  <input
                    type="text"
                    name="contact"
                    id="appfContact"
                    value={this.formatPhone(data.contact || "")}
                    onChange={this.handlePhoneChange}
                    className="form-control"
                    placeholder="Mobile No."
                  />
                </div>
                {errors.contact && <div className="alert alert-danger">{errors.contact}</div>}
              </div>
            </div>
          </div>

          <div className="appf-section">
            <div className="appf-section-header">
              <div className="appf-section-icon"><i className="fa fa-map-marker" /></div>
              <span className="appf-section-title">Location</span>
            </div>

            <div className="row">
              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfStateList">
                  <i className="fa fa-globe" /> State
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-globe appf-input-icon" aria-hidden="true" />
                  <select
                    className="form-control appf-select"
                    id="appfStateList"
                    name="state"
                    value={selectedStateId}
                    onChange={this.handleStateChanged}
                  >
                    <option value="0">Select State</option>
                    {stateList.map((s) => (
                      <option key={s.geonameId} value={s.geonameId}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="col-lg-6 form-group">
                <label className="form-control-label" htmlFor="appfCounty">
                  <i className="fa fa-building" /> City
                </label>
                <div className="appf-input-wrap">
                  <i className="fa fa-building appf-input-icon" aria-hidden="true" />
                  <input
                    type="text"
                    name="county"
                    id="appfCounty"
                    value={data.county || ""}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="City"
                  />
                </div>
                {errors.county && <div className="alert alert-danger">{errors.county}</div>}
              </div>
            </div>
          </div>
        </div>

        <div className="appf-form-footer">
          <button
            type="button"
            className="btn-action-search"
            onClick={this.props.handlePermissionShowHide}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back to Users
          </button>
          <button
            className="btn-action-search btn-primary-search"
            disabled={this.validate()}
            onClick={this.handleSubmit}
          >
            <i className="fa fa-check" aria-hidden="true" />
            {isEditMode ? "Save Changes" : "Add User"}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  partnerUserTypes: getCodeManager("Partner User Role")(state),
});

const mapDispatchToProps = {
  loadCodeManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPartnerPerformer);
